import { createFileRoute } from '@tanstack/react-router';

import { getSamplingQueries, SamplingPlanPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/sampling-plans_/$id')({
  loader: async ({ context, params }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.plans.detail(Number(params.id)),
    );
  },
  component: SamplingPlanPage,
});
